import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../translate/Translate';

// Components
import Date from '../../common/Date';
import LoadMore from '../../common/LoadMore';

// Helpers
import { deformatQuery } from '../../../helpers';

const ActivityHistory = observer(
  class ActivityHistory extends React.Component {
    componentDidMount() {
      this.listActivity();
    }

    listActivity = () => {
      const { store } = this.props;
      const { ActivityStore, UserStore } = store;
      const { targetUserData } = UserStore;

      const query = {
        targetUserSid: targetUserData.userSid,
        limit: 24,
        sortOrder: 'DESC'
      };

      ActivityStore.listAssessmentGroupActivity(query, false);
    };

    render() {
      const { store, translation } = this.props;
      const { ActivityStore, AppStore } = store;
      const { reportActivity, reportActivityNext } = ActivityStore;

      if (!AppStore.loading && reportActivity.length) {
        return (
          <div className="page__content wrap">
            <div className="page__primary">
              <h1 id="page-title" className="page__heading">
                {translation.heading}
              </h1>
              <table>
                <caption className="meta">{translation.heading}</caption>

                <thead>
                  <tr>
                    <th scope="col">{translation.date}</th>
                    <th scope="col">{translation.user}</th>
                    <th scope="col">{translation.action}</th>
                    <th scope="col">{translation.page}</th>
                    <th scope="col">{translation.resource}</th>
                  </tr>
                </thead>

                <tbody>
                  {reportActivity.map((activity, i) => (
                    <tr key={i}>
                      <td>
                        <Date
                          {...this.props}
                          date={activity.eventTimestamp}
                          dateFormat="M/d/yy h:mm a"
                        />
                      </td>
                      <td>{`${activity.user.firstName} ${activity.user.lastName}`}</td>
                      <td>{activity.eventName}</td>
                      <td>
                        {activity.eventName === 'Page View' && activity.metaData.title ? activity.metaData.title : ''}
                        {activity.eventName === 'Attempt Started' || activity.eventName === 'Attempt Completed' ? activity.metaData.assessmentName : ''}
                      </td>
                      <td>
                        {activity.metaData.url && activity.metaData.label ? (
                          <a href={activity.metaData.url}>{activity.metaData.label}</a>
                        ) : (
                          ''
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {reportActivityNext && (
                <LoadMore
                  {...this.props}
                  buttonText={translation.load_more}
                  loadFunction={callback => {
                    ActivityStore.listAssessmentGroupActivity(
                      deformatQuery(reportActivityNext),
                      true,
                      callback
                    );
                  }}
                  infinite={true}
                />
              )}
            </div>
          </div>
        );
      } else {
        return null;
      }
    }
  }
);

export default translate('ActivityHistory')(ActivityHistory);
